import { render, staticRenderFns } from "./tempGun.vue?vue&type=template&id=10e5ca48&scoped=true&"
import script from "./tempGun.vue?vue&type=script&lang=js&"
export * from "./tempGun.vue?vue&type=script&lang=js&"
import style0 from "./tempGun.vue?vue&type=style&index=0&id=10e5ca48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e5ca48",
  null
  
)

export default component.exports